<rms-mod [flippable]="true" transitionMode="morph"
         [flipped]="!!SelectedPosition"
         collapsedWidth="100%"
         expandedWidth="100%"
         height="calc(100vh - 100px)"
         [includeHeader]="false"
         [backButton]="!!SelectedPosition"
         (backButtonClicked)="clearSelection()">
  <div mod-front class="futures-list-screen">

    <div class="top-bar-row">
      <div class="stat-cards">
        <div class="summary-card card-positions">
          <div class="summary-label">Open Positions</div>
          <div class="summary-value">{{ Stats.Positions }}</div>
        </div>
        <div class="summary-card card-partial">
          <div class="summary-label">Partial Positions</div>
          <div class="summary-value">{{ Stats.Partial }}</div>
          <div class="summary-sub">{{ Stats.PartialWeightLbs | number:'1.0-0' }} lbs</div>
        </div>
        <div class="summary-card card-contracts">
          <div class="summary-label">Contracts</div>
          <div class="summary-value">{{ Stats.Contracts | number:'1.0-2' }}</div>
        </div>
        <div class="summary-card card-weight">
          <div class="summary-label">Total Active Weight</div>
          <div class="summary-value">{{ Stats.WeightLbs | number:'1.0-0' }} lbs</div>
        </div>
        <div class="summary-card card-customers">
          <div class="summary-label">Customers</div>
          <div class="summary-value">{{ Stats.Customers }}</div>
        </div>
        <div class="summary-card card-fnd">
          <div class="summary-label">Next First Notice Day</div>
          <div class="summary-value">{{ Stats.NextFND ? (Stats.NextFND | date:'MM/dd/yyyy':'UTC') : '—' }}</div>
          <div class="summary-sub">{{ Stats.NextFNDLabel }}</div>
        </div>
      </div>
    </div>

    @if (Loaded) {
    <rms-tab-group>

      <rms-tab label="Positions">
        <ng-template>
          <div class="contract-filters">
            <span class="filter-label">Contract:</span>
            <button class="filter-chip" [class.active]="!ContractFilter" (click)="selectContractFilter(null)">All ({{ AllRows.length }})</button>
            @for (c of ContractCounts; track c.name) {
            <button class="filter-chip" [class.active]="ContractFilter === c.name" (click)="selectContractFilter(c.name)">
              {{ c.name }} ({{ c.count }})
            </button>
            }
            <label class="closed-toggle">
              <input type="checkbox" [checked]="IncludeClosed" (change)="toggleIncludeClosed()" />
              Include closed positions
            </label>
          </div>
          <rms-table class="positions-table" [HeaderButtons]="Buttons"
                     [parentContext]="this"
                     [clickableRow]="true"
                     (onRowClick)="openPosition($event.row)"
                     [data]="PositionRows"
                     [columns]="PositionColumns"
                     tableId="futures-management-positions"
                     [customizable]="true"
                     startSort="FND"
                     startSortDirection="asc">
          </rms-table>
        </ng-template>
      </rms-tab>

      <rms-tab label="Customer Summary">
        <ng-template>
          <rms-table [parentContext]="this"
                     [data]="CustomerRows"
                     [columns]="CustomerColumns"
                     tableId="futures-management-customers"
                     startSort="WeightLbs"
                     startSortDirection="desc">
          </rms-table>

          @if (SelectedCustomer) {
          <div class="section customer-breakdown">
            <div class="breakdown-header">
              <h4>{{ SelectedCustomer.Customer }} · positions by futures month</h4>
              <button class="btn-bg-blue" (click)="selectCustomer(null)">Clear</button>
            </div>

            <div class="stat-cards">
              <div class="summary-card card-weight">
                <div class="summary-label">Open Weight</div>
                <div class="summary-value">{{ SelectedCustomer.WeightLbs | number:'1.0-0' }} lbs</div>
              </div>
              <div class="summary-card card-contracts">
                <div class="summary-label">Contracts</div>
                <div class="summary-value">{{ SelectedCustomer.Contracts | number:'1.0-2' }}</div>
              </div>
              <div class="summary-card card-fnd">
                <div class="summary-label">Next First Notice Day</div>
                <div class="summary-value">{{ SelectedCustomer.NextFND ? (SelectedCustomer.NextFND | date:'MM/dd/yyyy':'UTC') : '—' }}</div>
              </div>
            </div>

            <rms-table [parentContext]="this"
                       [data]="SelectedCustomerMonths"
                       [columns]="CustomerMonthColumns"
                       tableId="futures-management-customer-months"
                       startSort="FND"
                       startSortDirection="asc">
            </rms-table>
          </div>
          } @else {
          <div class="hint">Click a customer to see their positions by futures month.</div>
          }
        </ng-template>
      </rms-tab>

      <rms-tab label="Risk Notifications">
        <ng-template>
          <div class="contract-filters">
            <span class="filter-label">Status:</span>
            <button class="filter-chip" [class.active]="!RiskFilter" (click)="selectRiskFilter(null)">All ({{ RiskNotifications.length }})</button>
            <button class="filter-chip" [class.active]="RiskFilter === 'Delivered'" (click)="selectRiskFilter('Delivered')">Delivered ({{ RiskCounts.Delivered }})</button>
            <button class="filter-chip" [class.active]="RiskFilter === 'Pending'" (click)="selectRiskFilter('Pending')">Pending ({{ RiskCounts.Pending }})</button>
            <button class="filter-chip" [class.active]="RiskFilter === 'Failed'" (click)="selectRiskFilter('Failed')">Failed ({{ RiskCounts.Failed }})</button>
          </div>
          <rms-table [parentContext]="this"
                     [data]="RiskRows"
                     [columns]="RiskColumns"
                     tableId="futures-management-risk"
                     startSort="LastAttemptDate"
                     startSortDirection="desc">
          </rms-table>
        </ng-template>
      </rms-tab>

      <rms-tab label="By Futures Month">
        <ng-template>
          <rms-table [parentContext]="this"
                     [data]="MonthRows"
                     [columns]="MonthColumns"
                     tableId="futures-management-months"
                     startSort="FND"
                     startSortDirection="asc">
          </rms-table>
        </ng-template>
      </rms-tab>

    </rms-tab-group>
    } @else {
    <div class="loading">Loading...</div>
    }
  </div>

  <div mod-back class="futures-detail-screen">
    @if (SelectedPosition) {
    <app-futures-detail [position]="SelectedPosition" [reserveLines]="SelectedReserveLines"></app-futures-detail>
    }
  </div>
</rms-mod>
